
































import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

import { PluginMixin } from '../../../mixins/plugin'

@Component
export default class NoItem extends Mixins<PluginMixin>(PluginMixin) {
  get urlToContinueShopping() {
    return this.$store.getters['history/urlToContinueShopping']
  }
}
